import { compose, cond, filter, find, has, join, prepend, prop, propEq, propOr, props, trim } from 'ramda';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { EMPTY_VALUES } from 'constants/general';
import { equalOrThreeDashes } from 'utils';

export const getOwnerValue = (solver, agencies, regions, propType = 'description') => {
	const getPersonName = (property) =>
		compose(
			trim,
			join(' '),
			prepend(getLabelMessage(`sidebar:${property}`)),
			props(['surname', 'firstName']),
			prop(property),
		)(solver);

	const getAgencyName = (agencyId, regionId, codelist) => {
		const chosenAgency = compose(
			find(propEq(regionId, 'regionId')), // regionId FILTER
			filter(propEq(agencyId, 'agencyId')), // all agencyId FILTER
		)(codelist);

		const chosenAgencyCompany = propOr(EMPTY_VALUES.STRING, 'company')(chosenAgency);

		return chosenAgencyCompany === 'GLI'
			? `${agencyId} - ${propOr(EMPTY_VALUES.STRING, propType)(chosenAgency)}`
			: propOr(EMPTY_VALUES.STRING, propType)(chosenAgency);
	};

	const getRegionName = (regionId, codelist) => {
		const chosenRegion = find(propEq(regionId, 'regionId'), codelist);

		const chosenRegionCompany = propOr(EMPTY_VALUES.STRING, 'company')(chosenRegion);
		return chosenRegionCompany === 'GLI'
			? `${regionId} - ${propOr(EMPTY_VALUES.STRING, propType)(chosenRegion)}`
			: propOr(EMPTY_VALUES.STRING, propType)(chosenRegion);
	};

	const owner = cond([
		[has('ppz'), () => getPersonName('ppz')],
		[has('seller'), () => getPersonName('seller')],
		[has('manager'), () => getPersonName('manager')],
		[has('agencyId'), (solver) => getAgencyName(solver.agencyId, solver.regionId, agencies)],
		[has('regionId'), (solver) => getRegionName(solver.regionId, regions)],
	])(solver);

	return owner;
};

export const getOwnerValueWithSolverName = (solverName, solver, agencies, regions, propType = 'description') => {
	const getPersonName = (property, solverName) => {
		const solver = equalOrThreeDashes(solverName);
		const role = getLabelMessage(`sidebar:${property}`);

		return join(' ', [role, solver]);
	};

	const getAgencyName = (agencyId, regionId, codelist) => {
		const chosenAgency = compose(
			find(propEq(regionId, 'regionId')), // regionId FILTER
			filter(propEq(agencyId, 'agencyId')), // all agencyId FILTER
		)(codelist);

		const chosenAgencyCompany = propOr(EMPTY_VALUES.STRING, 'company')(chosenAgency);

		return chosenAgencyCompany === 'GLI'
			? `${agencyId} - ${propOr(EMPTY_VALUES.STRING, propType)(chosenAgency)}`
			: propOr(EMPTY_VALUES.STRING, propType)(chosenAgency);
	};

	const getRegionName = (regionId, codelist) => {
		const chosenRegion = find(propEq(regionId, 'regionId'), codelist);

		const chosenRegionCompany = propOr(EMPTY_VALUES.STRING, 'company')(chosenRegion);
		return chosenRegionCompany === 'GLI'
			? `${regionId} - ${propOr(EMPTY_VALUES.STRING, propType)(chosenRegion)}`
			: propOr(EMPTY_VALUES.STRING, propType)(chosenRegion);
	};

	const owner = cond([
		[has('ppz'), () => getPersonName('ppz', solverName)],
		[has('seller'), () => getPersonName('seller', solverName)],
		[has('manager'), () => getPersonName('manager', solverName)],
		[has('agencyId'), (solver) => getAgencyName(solver.agencyId, solver.regionId, agencies)],
		[has('regionId'), (solver) => getRegionName(solver.regionId, regions)],
	])(solver, solverName);

	return owner;
};
